module.exports = __webpack_public_path__ + "static/media/houston-field-trip-health.d0cc1433.jpg";